import React from 'react';
import { DataCell } from './ViewRefundItem';
import styles from "../styles.module.scss";
import { formatDate } from '../../../../studentRefundRequest/multiTypeRefund/utils';
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';

const ViewRefundDetails = ({
     refundDetails,
     isDLPCase
     }) => {
    const { isLoanCase , refundApplicationDate, batchStartDate, batchEndDate, loanOutstanding, preClosureReferenceDate } = refundDetails ?? {};

    const labelFieldMapping = [
        { label: 'Refund Application Date', renderExtra : formatDate(refundApplicationDate) },
        ...(!isDLPCase ? [
        { label: 'Batch Start Date', renderExtra : formatDate(batchStartDate) },
        { label: 'Batch End Date', renderExtra : formatDate(batchEndDate) },
        ] : []),
        ...(isLoanCase ? [
            { label: 'Pre-closure letter ref no.', field: "preClosureReferenceNumber" },
            { label: 'Pre-closure letter ref no. date', renderExtra : formatDate(preClosureReferenceDate)},
            { label: 'Loan O/S as per pre-closure letter', renderExtra : formattedPrice(loanOutstanding) },
        ] : [])
    ]
    return (
        <div className={`${styles['three-cols-grid']} mb-2`}>
            {labelFieldMapping?.map(el => {
                const { label, field, renderExtra } = el;
                return (
                    <DataCell
                        label={label}
                        value={refundDetails[field]}
                        key={field}
                    >
                        {renderExtra}
                    </DataCell>
                )
            })}

        </div>

    );
}

export default ViewRefundDetails;